import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

const TypingEffect = ({ text = "", speed = 100, sx = {} }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    const words = (text || "").replace(/undefined|null/gi, "").split(/\s+/).filter(Boolean);
    let i = 0;
    setDisplayedText("");
    setDone(false);

    const interval = setInterval(() => {
      if (i < words.length) setDisplayedText((prev) => prev + (i ? " " : "") + words[i++]);
      else { clearInterval(interval); setDone(true); }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return (
    <Typography
      variant="body2"
      sx={{ whiteSpace: "pre-line", lineHeight: 1.7, fontStyle: "italic", ...sx }}
    >
      {displayedText}
      {!done && (
        <Box
          component="span"
          sx={{
            display: "inline-block",
            width: "6px",
            height: "1em",
            backgroundColor: "currentColor",
            ml: "2px",
            animation: "blink 1s step-end infinite",
            "@keyframes blink": { "0%,100%": { opacity: 0 }, "50%": { opacity: 1 } },
          }}
        />
      )}
    </Typography>
  );
};

export default TypingEffect;

